export const fieldTemplates = [
  {
    label: 'Before Request',
    key: 'beforeRequest',
    type: 'code-editor',
    maxLines: 38,
    help_text_html:
      'Edit the JavaScript code that runs before we send every HTTP request. You can modify the <a href="https://docs.zapier.com/platform/build-cli/making-http-requests#http-request-options" target="_blank"><code>request</code></a> object, e.g. to add custom headers. Return <code>request</code> when you are done. <a href="https://docs.zapier.com/platform/reference/cli-docs#using-http-middleware" target="_blank">Learn more</a>.',
  },
  {
    label: 'After Response',
    key: 'afterResponse',
    type: 'code-editor',
    maxLines: 38,
    help_text_html:
      'Edit the JavaScript code that runs after we receive each HTTP response. You can modify the <a href="https://docs.zapier.com/platform/build-cli/making-http-requests#http-response-object" target="_blank"><code>response</code></a> object or use it, e.g. to extract and throw errors. Return <code>response</code> when you are done. <a href="https://docs.zapier.com/platform/reference/cli-docs#using-http-middleware" target="_blank">Learn more</a>.',
  },
];
